// Print specific element while keeping original DOM+events

window.printElement = function(el) {
  const body = document.body;
  const original = [...body.children];
  const clone = el.cloneNode(true);
  // let links = [];

  while (body.firstChild) {
    // if (body.firstChild.nodeName.toLowerCase() == 'link') {
    //   links.push(body.firstChild.cloneNode(true));
    // }

    body.firstChild.remove();
  }

  // for (let link of links) {
  //   body.append(link);
  // }
  body.append(clone);
  body.classList.add('js-printing');

  // setTimeout(() => {
    window.print();

    body.classList.remove('js-printing');

    while (body.firstChild) {
      body.firstChild.remove();
    }

    for (const child of original) {
      body.append(child);
    }
  // }, 10);
};
